import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import { toLabelSelectItems } from '../../../Label'

import { EMAIL_PROFILE_WIDGET_LABELS_FIELD_NAME } from './EmailProfileWidgetLabels.constants'

export function getEmailProfileWidgetLabelsInitialValues(labels) {
  return {
    [EMAIL_PROFILE_WIDGET_LABELS_FIELD_NAME]: toLabelSelectItems(
      labels || EMPTY_LIST
    ),
  }
}

export function getEmailProfileWidgetLabelsPayload(values) {
  return {
    [EMAIL_PROFILE_WIDGET_LABELS_FIELD_NAME]: getItemsIds(
      values[EMAIL_PROFILE_WIDGET_LABELS_FIELD_NAME],
      'value'
    ),
  }
}
